









import { Vue, Component, Prop } from 'vue-property-decorator';
import Title from '@/components/utils/Title.vue';
import Select from '@/components/utils/Select.vue';
import FormGroup from '@/components/form/FormGroup.vue';

@Component({
  components: {
    Title,
    Select,
    FormGroup,
  },
})
export default class Branches extends Vue {
  DESCENDING_SORTING: string = 'Trier du plus récent au plus ancien';

  ASCENDING_SORTING: string = 'Trier du plus ancien au plus récent';

  currentSort: number = 1;

  title: Object = {
    label: 'Formulaires',
    description:
      "Cher administrateur, vous avez la possibilité de visualiser les formulaires remplis par les gestionnaires pour leur lignes respectives. La modification des informations n'est pas permise ici. ",
  };

  selectItems: Array<any> = [this.ASCENDING_SORTING, this.DESCENDING_SORTING];

  async mounted() {
    await this.$store.dispatch('form/a_get_list');
    await this.$store.dispatch('branche/a_init_Branches');
  }

  get compList(): any {
    const branches = this.$store.getters['branche/list'] || [];
    const forms = this.$store.getters['form/list'] || [];
    return forms.map((form: any) => ({ ...form, branch: branches.find((branch: any) => branch.id === form.id_antenne) }));
  }

  sortBy(sort: string): void {
    if (this.ASCENDING_SORTING === sort) {
      this.currentSort = -1;
    } else if (this.DESCENDING_SORTING === sort) {
      this.currentSort = 1;
    } else {
      this.currentSort = 0;
    }
  }
}
